import { performPutRequest } from '@atlassian/jira-fetch/src/index.tsx';
import type { FieldKey } from '@atlassian/jira-polaris-domain-field/src/field/types.tsx';
import type { IssueTypeId, ProjectId } from '@atlassian/jira-shared-types/src/general.tsx';

export const performUpdatePinnedFields = ({
	projectId,
	issueTypeId,
	pinnedFields,
}: {
	projectId: ProjectId;
	issueTypeId: IssueTypeId;
	pinnedFields: FieldKey[];
}) =>
	performPutRequest(
		`/rest/polaris/v2/project/${projectId}/settings/issuetype/${issueTypeId}/pinned-fields`,
		{
			body: JSON.stringify({ pinnedFields }),
		},
	);
